import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';
import { AppSettings } from '../app-settings';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class SeatMapService {

  private saveBtn = new BehaviorSubject<boolean>(false);
  public saveEvent = this.saveBtn.asObservable();

  // Cambiar API
  constructor(private http: HttpClient) { }

  saveMapEvent(value: boolean) {
    this.saveBtn.next(value);
  }

  getLevelsVersionMap(id_space: number, id_version: number) {
    const url = `${AppSettings.API_URI_V2}/space/${id_space}/levels/map-version/${id_version}`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data;
      })
    );
  }

  editMap(mapJson: any, idMap: number) {
    const url = `${AppSettings.API_URI}/edit/map/${idMap}`;
    return this.http.put<any>(url, mapJson).pipe(
      map(data => {
        return data;
      })
    );
  }

  deleteMap(idMap: number) {
    const url = `${AppSettings.API_URI}/delete/map/${idMap}`;
    return this.http.delete<any>(url).pipe(
      map(data => {
        return data;
      })
    );
  }
}